import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepLabel from '@material-ui/core/StepLabel';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import { useMutation, useQueryClient } from 'react-query';
import { useHistory } from 'react-router';
import ThematicPackageSelection from './deploy-thematic-package/ThematicPackageSelection';
import { useAlerts } from '../../../hooks/alerts-hooks';
import DeploymentReview from './deploy-thematic-package/DeploymentReview';
import AppButtonMain from '../../basic/AppButtonMain';
import AppButtonMinimal from '../../basic/AppButtonMinimal';
import { getTheme } from '../../../theme';
import axiosClient from '../../../http/axios-client';
import DeploymentStatus from './deploy-thematic-package/DeploymentStatus';
import { eshopPages } from '../../../pages/EshopPage';
import ProductDetails from './deploy-thematic-package/ProductDetails';

const useStyles = makeStyles((theme) => {
  return {
    root: {
      width: '100%',
    },
    backButton: {
      marginRight: theme.spacing(1),
    },
    instructions: {
      marginTop: theme.spacing(1),
      marginBottom: theme.spacing(1),
    },
  };
});

function getSteps() {
  return [ 'Select a thematic package', 'Add product details', 'Review your deployment', 'Deploy thematic package to Eshop' ];
}

const DeployThematicPackage = (props) => {
  const { notDeployedThematicPackages } = props;
  const history = useHistory();
  const classes = useStyles();
  const [ activeStep, setActiveStep ] = React.useState(0);
  const [ selectedThematicPackage, setSelectedThematicPackage ] = React.useState(undefined);

  const [ productDetails, setProductDetails ] = useState({});

  const setProductDetailsProperty = (property, value) => {
    setProductDetails((prevProductDetails) => {
      return {
        ...prevProductDetails,
        [property]: value,
      };
    });
  };

  const numRegex = /^[+-]?\d+(\.\d+)?$/;

  const re = /(^100([.]0{1,2})?)$|(^\d{1,2}([.]\d{1,2})?)$/;

  const steps = getSteps();
  //   id: selectedThematicPackage?.id,
  // measurement_unit: productDetails.measurementUnit etc
  const body = {
    name: selectedThematicPackage?.name,
    description: selectedThematicPackage?.description,
    measurement_unit: productDetails.measurement_unit,
    tax: productDetails.tax,
    accounting_category: productDetails.accounting_category,
    barcode: productDetails.barcode,
    thematicGroup_id: productDetails.thematicGroup_id?.id,
    business_unit: productDetails.business_unit,
    wholesale_price: productDetails.wholesale_price,
    retail_price: productDetails.retail_price,
  };

  // update thematic package from step 2 in one step on deploy (final step),state vars here etc...
  const { alertInfo, alertSuccess, alertError } = useAlerts();
  const clientQuery = useQueryClient();

  const {
    mutate: deploy,
    isLoading: isDeploying,
  } = useMutation(
    [ 'deploy-thematic-package', selectedThematicPackage?.id ],
    (payload) => {
      console.log('payload: ', payload);

      return axiosClient.post('thematicpackages/eshop-deploy', payload);
    },
    {
      onSuccess() {
        history.push({
          pathname: '/eshop',
          search: `?page=${ eshopPages.DEPLOYED_THEMATIC_PACKAGES }`,
        });
        alertSuccess('Successful deployment');
      },
      onError(err) {
        alertError(err?.response?.data?.message || 'Failed to deploy product');
      },
      onSettled() {
        return clientQuery.invalidateQueries([ 'thematic-packages' ]);
      },
    },
  );

  const {
    mutate: update,
    isLoading: isUpdating,
  } = useMutation(
    [ 'thematic-packages', selectedThematicPackage?.id ], (payload) => {
      console.log('payload on update: ', payload);
      console.log('id on update: ', selectedThematicPackage?.id);
      return axiosClient.put(`thematicpackages/${ selectedThematicPackage?.id }`, payload);
    },
    {
      onSuccess() {
        console.log(isUpdating);
        console.log('sucessfully updated');
        // alertSuccess('Thematic Package Successfully updated');
        return deploy({ id: selectedThematicPackage?.id });
      },
      onError(err) {
        console.log('error: ', err);
        alertError(err?.response?.data?.message);
      },
    },
  );

  const handleNext = () => {
    if (selectedThematicPackage === undefined) {
      alertInfo('Please select a thematic package');
      return;
    }
    if (0 === activeStep && selectedThematicPackage !== undefined) {
      setProductDetails(selectedThematicPackage);
    }

    if (null === selectedThematicPackage.thematicGroup_id && productDetails.thematicGroup_id === undefined && 1 === activeStep) {
      alertInfo('You must connect the thematic package with a thematic group');
      return;
    }
    if ((undefined === productDetails.measurement_unit
    || undefined === productDetails.accounting_category
    || undefined === productDetails.barcode
    || undefined === productDetails.business_unit) && 1 === activeStep) {
      alertInfo('You must enter all the information required');
      return;
    }
    if ((!re.test(productDetails.tax)) && 1 === activeStep) {
      alertInfo('Tax must be only number in range 0-100');
      return;
    }
    if ((!numRegex.test(productDetails.wholesale_price) || !numRegex.test(productDetails.retail_price)) && 1 === activeStep) {
      alertInfo('Prices must only be numbers');
      return;
    }
    setActiveStep((prevActiveStep) => { return prevActiveStep + 1; });
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => { return prevActiveStep - 1; });
  };

  const handleReset = () => {
    setActiveStep(0);
  };

  const handleOnChange = (e, v) => {
    console.log('on change');
    console.log(v);
    setSelectedThematicPackage(v);
  };

  return (
    <div className={ classes.root }>
      <Stepper
        style={ { marginBottom: getTheme().spacing(4) } }
        activeStep={ activeStep }
        alternativeLabel
      >
        {steps.map((label) => {
          return (
            <Step key={ label }>
              <StepLabel>{label}</StepLabel>
            </Step>
          );
        })}
      </Stepper>
      <div>
        {activeStep === steps.length ? (
          <div>
            <Typography className={ classes.instructions }>All steps completed</Typography>
            <Button onClick={ handleReset }>Reset</Button>
          </div>
        ) : (
          <div>
            <Typography className={ classes.instructions }>
              {
                <div style={ { ...0 !== activeStep && { display: 'none' } } }>
                  <ThematicPackageSelection
                    options={ notDeployedThematicPackages }
                    value={ selectedThematicPackage }
                    onChange={ handleOnChange }
                  />
                </div>

              }
              {
                <div style={ { ...1 !== activeStep && { display: 'none' } } }>
                  <ProductDetails
                    thematicPackage={ selectedThematicPackage }
                    productDetails={ productDetails }
                    setProductDetailsProperty={ setProductDetailsProperty }
                  />
                </div>
              }
              {
                <div style={ { ...2 !== activeStep && { display: 'none' } } }>
                  <DeploymentReview
                    thematicPackage={ selectedThematicPackage }
                    { ...productDetails }
                  />
                </div>

              }
              {
                <div style={ { ...3 !== activeStep && { display: 'none' } } }>
                  <DeploymentStatus loading={ isDeploying } />
                </div>
              }
            </Typography>
            <div>
              <AppButtonMinimal
                disabled={ 0 === activeStep }
                onClick={ handleBack }
                className={ classes.backButton }
                text='Back'
              />
              <AppButtonMain
                disabled={ isDeploying }
                onClick={ () => {
                  // edw thele ena allo request gia na kanei post sto endpoint thematic packages
                  // an to activeStep = deutero step
                  if (steps.length - 1 === activeStep) {
                    console.log('body of request: ', body);
                    return update(body);
                    // return deploy({ id: selectedThematicPackage?.id });//
                  }
                  return handleNext();
                } }
                text={ activeStep === steps.length - 1 ? 'Deploy' : 'Next' }
              />
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default DeployThematicPackage;
/*
<p>{JSON.stringify({ productDetails })}</p>
*/
